import { render, staticRenderFns } from "./breadcrumb-nav.vue?vue&type=template&id=5caa26c0"
import script from "./breadcrumb-nav.vue?vue&type=script&lang=ts"
export * from "./breadcrumb-nav.vue?vue&type=script&lang=ts"
import style0 from "./breadcrumb-nav.vue?vue&type=style&index=0&id=5caa26c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports